module.exports = __webpack_public_path__ + "static/img/lotteryGame.bdc72a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/lotteryGame.png
// module id = KNlw
// module chunks = 3